const fmtDate = (s) => new Date(s).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" });

export default function EnrolmentsList({ enrolments }) {
  if (!enrolments) return <p className="text-[#57645A]">Loading…</p>;
  if (enrolments.length === 0) return <div className="bg-white border border-parchment-300 rounded-2xl p-10 text-center text-[#57645A]" data-testid="enrolments-empty">No course enrolments yet.</div>;

  return (
    <div className="bg-white border border-parchment-300 rounded-2xl overflow-hidden" data-testid="enrolments-list">
      {enrolments.map((e) => (
        <div key={e.id} className="grid grid-cols-[1fr_auto] sm:grid-cols-[1.2fr_1fr_1.4fr_0.8fr] gap-x-4 gap-y-1 px-5 py-4 border-b border-parchment-200 last:border-0 items-center" data-testid={`enrolment-row-${e.id}`}>
          <span className="font-semibold text-forest-800">{e.name}</span>
          <a href={`tel:+91${e.phone}`} className="text-sm text-[#57645A] justify-self-end sm:justify-self-auto">{e.phone}</a>
          <span className="text-sm text-forest-800 col-span-2 sm:col-span-1">{e.course_title}</span>
          <span className="text-xs text-[#8A978E] col-span-2 sm:col-span-1">{fmtDate(e.created_at)}</span>
        </div>
      ))}
    </div>
  );
}
